"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingSessionTrackerSerialization = void 0;
const ChargingSessionSerialization_1 = require("./ChargingSessionSerialization");
class ChargingSessionTrackerSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.charging_sessions = entity.charging_sessions?.map((field) => field
            ? JSON.parse(ChargingSessionSerialization_1.ChargingSessionSerialization.serialize(field))
            : undefined);
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.charging_sessions = entity.charging_sessions?.map((field) => field
            ? ChargingSessionSerialization_1.ChargingSessionSerialization.deserialize(JSON.stringify(field))
            : undefined);
        return copy;
    }
}
exports.ChargingSessionTrackerSerialization = ChargingSessionTrackerSerialization;
